import React, { FunctionComponent } from "react";
import EntrancesContent from "./EntrancesContent.model";
import styles from "./Entrances.module.scss";

import combineClasses from "helpers/combine-classes";
import Entrance from "./components/Entrance/Entrance";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";

const Entrances: FunctionComponent<EntrancesContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);
    const bgColor = props.settings?.backgroundColor?.color || "#d8e8c5";

    return (
        <div
            className={combineClasses([styles.wrapper, ...wrapperStyles])}
            style={{ backgroundColor: bgColor }}
        >
            <div className={styles.container}>
                <div className={styles.list}>
                    {/* Entrances */}
                    {props.content.entrances &&
                        props.content.entrances.map((entrance) => {
                            return (
                                <Entrance
                                    key={entrance.contentUdi}
                                    length={props.content.entrances?.length}
                                    {...entrance}
                                />
                            );
                        })}
                </div>
            </div>
        </div>
    );
};

export default Entrances;
